import React, { Component } from 'react';
import AuthService from '../../services/AuthService.js';

export class RecuperarClaveContentPanel extends Component {
    constructor(props) {
        super(props); 
    }
    render() {
        return (
            <div> 
                <div class="form-group">
                    <div className="form-row">
                        <label class="col-md-2">Usuario</label>
                        <input name="Usuario" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>  
            </div>
        );
    }
}

